// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import { toastError, toastSuccess } from '../../../utility/toastutill'
import { AddRequirement, deleteRequirementById, updateRequirementById, getById, getAllRequirements } from '../../../services/reqirements.service'


export const getRequirement = createAsyncThunk('Requirement/getRequirement', async params => {

  let query = ''
  if (params) {
    if (params.sort) {
      query = `${query}&sort=${params.sort}`
    }
    if (params.sortColumn) {
      query = `${query}&sortColumn=${params.sortColumn}`
    }
    if (params.q) {
      query = `${query}&q=${params.q}`
    }
    if (params.perPage) {
      query = `${query}&perPage=${params.perPage}`
    }
    if (params.page) {
      query = `${query}&page=${params.page}`
    }
    if (params.status) {
      query = `${query}&status=${params.status}`
    }
    if (params.startDate) {
      query = `${query}&startDate=${params.startDate}`
    }

    if (params.endDate) {
      query = `${query}&endDate=${params.endDate}`
    }
  }
  const response = await getAllRequirements(query)
  return {
    params,
    data: response.data.data,
    RequirementCount: response.data.RequirementCount
  }
})

export const getRequirementById = createAsyncThunk('Requirement/getRequirementById', async id => {
  try {
    const response = await getById(id)
    toastSuccess(response.data.message)
    return response.data.data
  } catch (error) {
    toastError(error)
    return error
  }
})

export const addRequirement = createAsyncThunk('Requirement/addRequirement', async (formData, { dispatch }) => {

  try {
    const res = await AddRequirement(formData)
    if (res.data) {
      toastSuccess(res.data.message)
      await dispatch(getRequirement())
    }

    return res.data.success ? res.data.success : false
  } catch (error) {
    toastError(error)
    return error
  }

})

export const updateRequirement = createAsyncThunk('Requirement/updateRequirement', async (formData, { dispatch }) => {

  try {
    const res = await updateRequirementById(formData.id, formData)
    if (res.data.success) {
      toastSuccess(res.data.message)
      await dispatch(getRequirement())
    }

    return res.data.success ? res.data.success : false
  } catch (error) {
    toastError(error)
    return error
  }

})

export const deleteRequirement = createAsyncThunk('Requirement/deleteRequirement', async (id, { dispatch }) => {
  try {
    const res = await deleteRequirementById(id)
    if (res.data.success) {
      toastSuccess(res.data.message)
      await dispatch(getRequirement())
    }
    return id
  } catch (error) {
    toastError(error)
    return error
  }
})

export const RequirementSlice = createSlice({
  name: 'Requirement',
  initialState: {
    data: [],
    params: {},
    allData: [],
    selectedRequirement: null,
    success: false
  },
  reducers: {

  },
  extraReducers: builder => {
    builder
      .addCase(getRequirement.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.RequirementCount
      })
      .addCase(getRequirementById.fulfilled, (state, action) => {
        state.selectedRequirement = action.payload
      })
      .addCase(addRequirement.fulfilled, (state, action) => {
        state.success = action.payload
      })
      .addCase(updateRequirement.fulfilled, (state, action) => {
        state.selectedRequirement = null
      })
  }
})

export default RequirementSlice.reducer
